import React from 'react';

import { Box } from '@chakra-ui/react';
import ProfileFieldCard from './ProfileFieldCard';
import { useUser } from '../../../../hooks/V2/useUser';

const Name = () => {
	const { data: profile } = useUser();
	return (
		<Box>
			<ProfileFieldCard heading="Name" title={profile?.name} />
		</Box>
	);
};

export default Name;
